module.exports = __webpack_public_path__ + "img/sec2.1.3cc59849.png";